// SmartBallot logo — gradient badge (white wordmark + fox/check on brand gradient).
export function Logo({ className = "h-9" }) {
  return (
    <img
      src="/smartballot-logo.png"
      alt="SmartBallot"
      className={`w-auto select-none ${className}`}
      draggable="false"
    />
  );
}
